import { render, staticRenderFns } from "./editarPropietario.vue?vue&type=template&id=6e19bc6e&scoped=true"
import script from "./editarPropietario.vue?vue&type=script&lang=js"
export * from "./editarPropietario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e19bc6e",
  null
  
)

export default component.exports